import {axios, HOST, config} from './settiing';

export default {
  //DriveLog
  getDriveLogById(id) {
    return axios.get(`${HOST}/manage/drive/${id}`, config)
  },
  getDriveLogByIdVoucherTaxi(id) {
    return axios.get(`${HOST}/manage/drive/kst/${id}`, config)
  },
  getDriveLogStatusIsAndStartTimeBetween(status, start, end) {
    return axios.get(`${HOST}/manage/drive/${status}/${start}/${end}`, config)
  },
  getDriveLogList(data) {
    config.params = data;
    const result = axios.get(`${HOST}/manage/drive-log/${data.startDate}/${data.endDate}`, config)
    config.params = null;
    return result;
  },
  getDriveLogListBySearchKeyword(data) {
    config.params = data;
    const result = axios.get(`${HOST}/manage/drive-log/${data.startDate}/${data.endDate}/${data.searchType}/${data.searchKeyword}`, config)
    config.params = null;
    return result;
  },
  getDriveLog2PayLogById(id) {
    return axios.get(`${HOST}/manage/drive/payLog/${id}`, config)
  },
  updateDriveLogFee(data) {
    return axios.put(`${HOST}/manage/drive/fee`, data, config);
  },
  updateDriveLogPay(data) {
    return axios.put(`${HOST}/manage/drive/extraPay`, data, config);
  },
  getDriveLogStatistics(start, end) {
    return axios.get(`${HOST}/manage/drive/statistics/${start}/${end}`, config)
  },
  getCardLogInfo(id) {
    return axios.get(`${HOST}/manage/drivelog/card/${id}`, config)
  },
  getEditAdminInfo(id) {
    return axios.get(`${HOST}/manage/drivelog/update/${id}`, config)
  },
  updateRiderCount(data){
    return axios.put(`${HOST}/manage/drive/riderCount`, data, config);
  },
  updatePassengerIsBoarded(data) {
    return axios.put(`${HOST}/manage/drive/reservation-passenger/boarded`, data, config);
  },
  updateUnknownPassengers(data) {
    return axios.put(`${HOST}/manage/reservation/unknown-passenger`, data, config);
  },
  driveForceDone(data) {
    return axios.post(`${HOST}/manage/drive/force-done`, data, config);

  },
  getDriveStatusCount(status) {
    return axios.get(`${HOST}/manage/drive/count/${status}`, config)
  }
}